<template>
    <div>
        <b-button
                v-b-modal="'move-department'"
                class="btn btn-warning btn-sm"
                :class="{ 'spinner spinner-white spinner-left': loadingMoveDepartment}"
                :title="ticket.is_feedback ? 'Đã nhập đánh giá không được phép chuyển phòng ban' : ''"
                :disabled="ticket.is_feedback || loadingMoveDepartment"
        >Chuyển xử lý
        </b-button>
        <b-modal
            id="move-department"
            title="Chuyển xử lý"
            size="xs"
            ok-title="Cập nhật"
            ok-only
            centered
            hide-footer
            @hide="closeModal"
        >
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                <form class="row">
                    <div class="form-group col-md-6">
                      <label>Chọn phương án <span style="color: red">*</span></label>
                      <ValidationProvider vid="plan" name="Phòng ban xử lý" rules="required"
                                          v-slot="{ errors,classes }">
                        <el-select
                            filterable
                            class="w-100"
                            placeholder="Chuyển phòng ban xử lý"
                            v-model="plan"
                            clearable
                        >
                          <el-option
                              v-for="item in planOption"
                              :key="item.id"
                              :label="item.value"
                              :value="item.id"
                          >
                            <span style="float: left">{{ item.value }}</span>
                          </el-option>
                        </el-select>
                        <div class="fv-plugins-message-container">
                          <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                              errors[0]
                            }}
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="form-group col-md-6" v-if="plan === 1">
                      <label>Phòng ban xử lý<span class="text-danger">*</span></label>
                      <ValidationProvider vid="department" name="Phòng ban xử lý"
                                          :rules="{ required: true }"
                                          v-slot="{ errors,classes }">
                        <el-select
                            filterable class="w-100" placeholder="Phòng ban xử lý"
                            v-model="department"
                            clearable
                        >
                          <el-option
                              v-for="item in departments"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                          >
                            <span style="float: left">{{ item.name }}</span>
                          </el-option>
                        </el-select>
                        <div class="fv-plugins-message-container">
                          <div data-field="name" data-validator="notEmpty"
                               class="fv-help-block">{{
                              errors[0] }}
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="form-group col-md-6" v-if="plan === 1">
                      <label>Danh mục<span class="text-danger">*</span></label>
                      <ValidationProvider vid="category" name="Danh mục"
                                          :rules="{ required: true }"
                                          v-slot="{ errors,classes }">
                        <el-select
                            filterable class="w-100" placeholder="Chọn danh mục"
                            v-model="category" clearable
                        >
                          <el-option
                              v-for="item in categories"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                          >
                            <span style="float: left">{{ item.name }}</span>
                          </el-option>
                        </el-select>
                        <div class="fv-plugins-message-container">
                          <div data-field="name" data-validator="notEmpty"
                               class="fv-help-block">{{
                              errors[0] }}
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="form-group col-md-6" v-if="plan === 1">
                      <label>Người xử lý</label>
                      <el-select
                          ref="userSelect"
                          v-model="handler"
                          filterable size="large"
                          remote class="w-100"
                          clearable
                          placeholder="Tìm kiếm người xử lý"
                          :remote-method="remoteMethod"
                          :loading="loading">
                        <el-option
                            v-for="item in handlerOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="form-group col-md-6" v-if="plan === 2">
                      <label>Trung tâm xử lý <span class="text-danger">*</span></label>
                      <ValidationProvider
                          vid="center" name="Chi nhánh xử lý"
                          :rules="{ required: true }"
                          v-slot="{ errors,classes }">
                        <el-select
                            filterable class="w-100"
                            placeholder="Trung tâm xử lý"
                            v-model="trung_tam_xu_ly"
                            clearable
                            @change="getBranches">
                          <el-option
                              v-for="item in centers"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                          >
                            <span style="float: left">{{ item.name }}</span>
                          </el-option>
                        </el-select>
                        <div class="fv-plugins-message-container">
                          <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                              errors[0] }}
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="form-group col-md-6" v-if="plan === 2">
                        <div class="form-group">
                            <label>Chi nhánh xử lý <span class="text-danger">*</span></label>
                          <ValidationProvider
                              vid="branch" name="Chi nhánh xử lý"
                              :rules="{ required: true }"
                              v-slot="{ errors,classes }">
                                <el-select filterable class="w-100" placeholder="Chi nhánh xử lý"
                                           v-model="chi_nhanh_xu_ly"
                                           clearable
                                >
                                    <el-option
                                        v-for="item in branches"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            <div class="fv-plugins-message-container">
                              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                                  errors[0] }}
                              </div>
                            </div>
                          </ValidationProvider>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
            <b-button
                    variant="success"
                    size="md"
                    class="float-right"
                    :disabled="loadingMoveDepartment"
                    :class="{'spinner spinner-white spinner-right' : loadingMoveDepartment}"
                    @click="handleOk"
            >
                Chuyển
            </b-button>
        </b-modal>
    </div>
</template>

<script>
    import {UPDATE_TICKET_FORM} from "../../../../../core/services/store/user/ticket.module";
    import { GET_CENTERS } from "@/core/services/store/center/centers.module";
    import { GET_BRANCHES } from "@/core/services/store/center/branch.module";
    import {GET_CATEGORY} from "../../../../../core/services/store/ticket-category/category.module";
    import {FIND_USER_BY_KEYWORD} from "../../../../../core/services/store/okrs/okr.module";
    import {QLHV} from "@/core/option/ticket";

    export default {
        name: "MoveDepartmentModal",
        props: {
            departments: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            ticket: {
                type: Object,
                default: () => {
                    return null;
                }
            },
        },
        data() {
            return {
                loadingMoveDepartment: false,
                department: '',
                trung_tam_xu_ly: '',
                chi_nhanh_xu_ly: '',
                centers: [],
                branches: [],
                categories: [],
                planOption: [
                  {
                    id: 1,
                    value: 'Chuyển phòng ban xử lý',
                  },
                  {
                    id: 2,
                    value: 'Chuyển QLHV xử lý',
                  },
                  {
                    id: 3,
                    value: 'Chuyển TTHT xử lý',
                  }
                ],
              plan: null,
              category: null,
              queryUser: '',
              handler: null,
              handlerOptions: [],
              loading: false,
            }
        },
        watch: {
          department(newVal, oldVal) {
            if (newVal !== oldVal) {
              this.handler = null;
              this.handlerOptions = [];
            }
            if (newVal) {
              this.getListTicketCategory();
            } else {
              this.categories = this.mergeCurrentCategoryToOptions([]);
            }
          },
          plan(){
            if (+this.plan === 1) {
              this.category = this.ticket.category_ticket?.id || this.ticket.category_ticket_id || null
              this.categories = this.mergeCurrentCategoryToOptions(this.categories || []);
              if (this.category) {
                this.syncHandlerByCategory(this.category);
              }
            }
          },
          category(newVal) {
            this.syncHandlerByCategory(newVal);
          }
        },
        mounted() {
            this.getCenters();
            if (+this.ticket.phong_ban_xu_ly === 1) {
                this.department = '';
            } else {
                this.department = this.ticket.phong_ban_xu_ly;
            }
        },
        methods: {
            getCurrentCategoryOption() {
              const categoryId = this.category || this.ticket?.category_ticket?.id || this.ticket?.category_ticket_id || null;
              if (!categoryId) return null;
              return {
                id: categoryId,
                name: this.ticket?.category_ticket?.name
                  || this.ticket?.category_ticket?.value
                  || this.ticket?.category_ticket?.category_name
                  || this.ticket?.category_name
                  || `Danh mục #${categoryId}`,
                user_handle_id: this.ticket?.category_ticket?.user_handle_id || null,
                user_handle_name: this.ticket?.category_ticket?.user_handle_name || '',
              };
            },
            mergeCurrentCategoryToOptions(categoryOptions = []) {
              const currentCategory = this.getCurrentCategoryOption();
              if (!currentCategory) return categoryOptions;
              const existed = categoryOptions.some(item => String(item.id) === String(currentCategory.id));
              if (existed) return categoryOptions;
              return [currentCategory, ...categoryOptions];
            },
            upsertHandlerOption(userId, userName = '') {
              if (!userId) return;
              const normalizedId = Number(userId);
              const existed = this.handlerOptions.find(item => Number(item.id) === normalizedId);
              if (existed) return;
              this.handlerOptions.unshift({
                id: normalizedId,
                name: `${normalizedId + 100000} - ${userName}`,
              });
            },
            syncHandlerByCategory(categoryId) {
              if (!categoryId) {
                this.handler = null;
                return;
              }
              const category = this.categories.find(item => String(item.id) === String(categoryId));
              const userHandleId = category?.user_handle_id ?? null;
              const userHandleName = category?.user_handle_name || category?.user_hanlde_name || '';
              this.handler = userHandleId;
              this.upsertHandlerOption(userHandleId, userHandleName);
            },
            getListTicketCategory() {
              this.loading = true;
              const payload = {
                limit: 1000,
                department_id: this.department,
              }
              this.$store.dispatch(GET_CATEGORY, payload).then((res) => {
                this.categories = this.mergeCurrentCategoryToOptions(res.data || [])
                this.last_page = res.pagination.last_page
                if (this.category) {
                  this.syncHandlerByCategory(this.category);
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => this.loading = false);
            },
            getUsers() {
              const payload = {
                keyword: this.queryUser,
              }
              this.$store.dispatch(FIND_USER_BY_KEYWORD, payload).then(res => {
                if (!res.error) {
                  this.handlerOptions = res.data.map(item => {
                    return {
                      id: item.id,
                      name: `${item.id + 100000} - ${item.name} - ${item.department_name}`,
                    }
                  }) ?? []
                }
              })
            },
            remoteMethod(query) {
              if (query !== '') {
                this.queryUser = query
                this.loading = true;
                setTimeout(() => {
                  this.loading = false;
                  this.getUsers()
                }, 400);
              } else {
                this.handlerOptions = [];
              }
            },
            cancelDepartment() {
              this.$store.dispatch(UPDATE_TICKET_FORM, {
                id: this.$route.params.id,
                status: 1,
                phong_ban_xu_ly: this.$route.name === 'crm-ticket-show' ? 1 : 31,
                trung_tam_xu_ly: '',
                chi_nhanh_xu_ly: '',
                is_transfer: true,
                checkbox_department_handle: '',
                cancel_move_department: true
              }).then((res) => {
                if (!res.error) {
                  this.$bvToast.toast('Chuyển TTHT thành công', {
                    title: 'Thành công',
                    variant: 'success',
                    solid: true
                  });
                  this.$emit('moveDepartment');
                  this.loadingCancelTransfer = false;
                  this.closeModal();
                }
              });
            },
            handleOk(e) {
              if (this.plan === 3) {
                this.cancelDepartment();
                return;
              }
              if (this.plan === 2 && !this.trung_tam_xu_ly || (this.plan === 1 && !this.department)) return;
              e.preventDefault();
              this.ticket.phong_ban_xu_ly = this.plan === 2 ? QLHV : this.department;
              this.ticket.trung_tam_xu_ly = this.trung_tam_xu_ly;
              this.ticket.chi_nhanh_xu_ly = this.chi_nhanh_xu_ly;
              this.ticket.checkbox_department_handle = this.plan;
              this.loadingMoveDepartment = true;
              let ticket_change = this.ticket;
              ticket_change.recipient_id = 3;
              ticket_change.is_transfer =  true;
              ticket_change.assigned_user_id = this.handler;
              if (this.plan === 1) {
                ticket_change.category_ticket_id = this.category
              }
              this.$store.dispatch(UPDATE_TICKET_FORM, ticket_change).then((data) => {
                this.$bvToast.toast('Chuyển phòng ban xử lý thành công', {
                  title: 'Thành công',
                  variant: 'success',
                  solid: true
                });
                this.closeModal()
                this.loadingMoveDepartment = false;
                this.$emit('moveDepartment');
              });
            },
            closeModal() {
              this.$bvModal.hide('move-department');
              this.plan = null
              this.department = null;
              this.category = null;
              this.handler = null;
              this.handlerOptions = [];
            },
            getCenters() {
              this.$store.dispatch(GET_CENTERS, {
                status: 1,
                limit: 100000
              }).then((data) => {
                if (!data.error) {
                  this.centers = data.data.data;
                }
              })
            },
            getBranches() {
              this.$store.dispatch(GET_BRANCHES, {
                status: 1,
                limit: 100000,
                center_ids: [this.trung_tam_xu_ly]
              }).then((data) => {
                if (!data.error) {
                  this.branches = data.data.data;
                }
              })
            },
        },
    }
</script>

<style scoped>

</style>